import React, { useState } from "react";
import "./BusMobileModifyForm.css";
import { FaRegArrowAltCircleLeft } from "react-icons/fa";
import { IoSearchOutline } from "react-icons/io5";
import { MdEdit } from "react-icons/md";
import BusForm from "../BusPhone/BusForm";
import { RxCross2 } from "react-icons/rx";
import moment from "moment";
import { Link } from "react-router-dom";

const BusMobileModifyForm = ({ origin, destination, journeyDate }) => {
  const [showBookingForm, setShowBookingForm] = useState(false);

  return (
    <div id="hotelSearch " className="hotelsearchmobile ">
      <div className="BuslistingMobile-headerRoute bus_list_modify-search">
        <Link to="/buses">
          <span className="BuslistingMobile-backArrow">
            <FaRegArrowAltCircleLeft color="#fff"/>
          </span>
        </Link>

        <div className="BuslistingMobile-routeInfo">
          <div className="BuslistingMobile-route">
            {origin || "Origin"} - {destination || "Destination"}
          </div>
          <div className="BuslistingMobile-date">
            {journeyDate
              ? moment(journeyDate, "YYYY-MM-DD").format("ddd, DD MMM")
              : "Select Date"}
          </div>
        </div>

        <div className="BuslistingMobile-icons">
          {/* <span>
            <IoSearchOutline />
          </span> */}
          <span
            onClick={() => setShowBookingForm(true)}
            style={{ cursor: "pointer" }}
          >
            <MdEdit color="#fff"/>
          </span>
        </div>
      </div>
      {showBookingForm && (
        <div className="BusBookingForm-editSearch">
          <div className="BusBookingForm-modal">
            <div className="BusBookingForm-header">
              <span
                className="BusBookingForm-close"
                onClick={() => setShowBookingForm(false)}
              >
                <RxCross2 size={22} />
              </span>
            </div>

            <BusForm
              origin={origin}
              destination={destination}
              journeyDate={journeyDate}
              onSearchComplete={() => setShowBookingForm(false)}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default BusMobileModifyForm;
